module.exports = __webpack_public_path__ + "img/audience-counter.8a43371b.jpg";